/* eslint-disable global-require,import/no-unresolved,react/no-string-refs,react/jsx-closing-tag-location, react/jsx-no-bind */
import React, { Component } from 'react'
import {
 Dimensions, ScrollView, Text, View,
} from 'react-native'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import LatitudeCommunicator from './Content/LatitudeCommunicator'
import RemoteScheduledFollowUp from './Content/RemoteScheduledFollowUp'
import RemoteMonitoringTerm from './Content/RemoteMonitoring'
import BostonScientific from './Content/BostonScientific'
import SICDTerm from './Content/SICDTerm'
import Pacemaker from './Content/Pacemaker'
import ICDTerm from './Content/ICDTerm'
import CommunicatorWorking from './Content/CommunicatorWorking'
import ImplantedBattery from './Content/ImplantedBattery'
import DeviceModels from '../DeviceModels'
import * as RegionalLookup from '../methods/RegionalContentLookUp'
import ManualDataTransmission from './Content/ManualDataTransmission'
import CovidStudy from './Content/CovidStudy'
import ICDPrecautions from './Content/ICDPrecautions'
import { CRTDPrecautions, CRTPPrecautions } from './Content/CRTPrecautions'
import PacemakerPrecautions from './Content/PacemakerPrecautions'
import BSCResearch from './Content/BSCResearch'

class FAQItemPage extends Component {
  constructor(props) {
    super(props)
    this.scrollViewRef = React.createRef()
  }

  renderTerm() {
    const {
      itemTapped,
      regionalContentLookup,
      deviceModel,
    } = this.props

    const deviceModelType = DeviceModels[deviceModel] ? DeviceModels[deviceModel].type : null

    if (itemTapped === 'whatIsCommunicator') {
      return (
        <LatitudeCommunicator />
      )
    }
    if (itemTapped === 'whatIsRemoteSchedFollowup') {
      return (
        <RemoteScheduledFollowUp />
      )
    }
    if (itemTapped === 'whatIsRemoteMonitoring') {
      return (
        <RemoteMonitoringTerm
          deviceModel={deviceModelType}
          regionalContentLookup={regionalContentLookup}
        />
      )
    }
    if (itemTapped === 'whoIsBostonScientific') {
      return (
        <BostonScientific regionalContentLookup={regionalContentLookup} />
      )
    }
    if (itemTapped === 'whatIsPacemaker') {
      return (
        <Pacemaker />
      )
    }
    if (itemTapped === 'whatIsSICD') {
      return (
        <SICDTerm />
      )
    }
    if (itemTapped === 'faqICD') {
      return (
        <ICDTerm />
      )
    }
    if (itemTapped === 'howKnowCommunicatorWorking') {
      return (
        <CommunicatorWorking />
      )
    }
    if (itemTapped === 'howBatteryWork') {
      return (
        <ImplantedBattery regionalContentLookup={regionalContentLookup} deviceModelType={deviceModelType} />
      )
    }
    if (itemTapped === 'manuallyTransmitDataTitle') {
      return (<ManualDataTransmission />)
    }
    if (itemTapped === 'covidNoticeDetailTitle') {
      return (<CovidStudy />)
    }
    if (itemTapped === 'icdPrecautionsTitle') {
      return (<ICDPrecautions />)
    }
    if (itemTapped === 'crtPrecautionsTitle.D') {
      return (<CRTDPrecautions />)
    }
    if (itemTapped === 'crtPrecautionsTitle.P') {
      return (<CRTPPrecautions />)
    }
    if (itemTapped === 'pacemakerPrecautionsTitle') {
      return (<PacemakerPrecautions />)
    }
    if (itemTapped === 'bscResearchTitle') {
      return (<BSCResearch />)
    }

    return (<Text style={[styles.textMargin, textStyles.bodyContentText]}>Term not found</Text>)
  }

  render() {
    const { t } = this.props
    const { height: heightOfDeviceScreen } = Dimensions.get('window')
    return (
      <View style={{ flex: 1 }}>
        <ScrollView
          contentContainerStyle={{ minHeight: this.height || heightOfDeviceScreen }}
          style={{
            backgroundColor: colors.white,
            flexGrow: 1,
          }}
          accessibilityLabel={t('access:faqItemDetailPage')}
          testID="scrollview-FAQItemPage"
          refs={this.scrollViewRef}
          bounces={false}
        >
          <View style={styles.faqContentContainer}>
            <View style={[styles.container, styles.termBody, { backgroundColor: colors.white }]}>
              {this.renderTerm()}
            </View>
          </View>
        </ScrollView>
      </View>
    )
  }
}

FAQItemPage.propTypes = {
  regionalContentLookup: PropTypes.func.isRequired,
  deviceModel: PropTypes.string,
  itemTapped: PropTypes.string,
  t: PropTypes.func.isRequired,
}

FAQItemPage.defaultProps = {
  deviceModel: null,
  itemTapped: null,
}

const actionCreators = {
  regionalContentLookup: RegionalLookup.regionalContentLookup,
}

const mapStateToProps = (state) => {
  const { faq, storedData } = state
  return {
    itemTapped: faq.currentFAQItem,
    deviceModel: storedData.deviceModel,
  }
}

export const FAQItemPageComponent = FAQItemPage

export default withTranslation(['faq'])(connect(mapStateToProps, actionCreators)(FAQItemPage))
